var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.375H20.1875C21.1016 3.375 21.875 4.14844 21.875 5.0625V14.625C22.4727 14.625 23 15.1523 23 15.75C23 16.3828 22.4727 16.875 21.875 16.875H20.1875H12.875V19.125C12.875 19.7578 12.3477 20.25 11.75 20.25C11.1172 20.25 10.625 19.7578 10.625 19.125V16.875H3.3125H1.625C0.992188 16.875 0.5 16.3828 0.5 15.75C0.5 15.1523 0.992188 14.625 1.625 14.625V5.0625C1.625 4.14844 2.36328 3.375 3.3125 3.375H7.25C7.25 2.77734 7.74219 2.25 8.375 2.25C8.97266 2.25 9.5 2.77734 9.5 3.375H14C14 2.77734 14.4922 2.25 15.125 2.25C15.7227 2.25 16.25 2.77734 16.25 3.375ZM11.75 14.625H19.625V5.625H16.25V6.75C16.8477 6.75 17.375 7.27734 17.375 7.875C17.375 8.50781 16.8477 9 16.25 9H15.125H14C13.3672 9 12.875 8.50781 12.875 7.875C12.875 7.27734 13.3672 6.75 14 6.75V5.625H9.5V6.75C10.0977 6.75 10.625 7.27734 10.625 7.875C10.625 8.50781 10.0977 9 9.5 9H8.375H7.25C6.61719 9 6.125 8.50781 6.125 7.875C6.125 7.27734 6.61719 6.75 7.25 6.75V5.625H3.875V14.625H11.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default ForwardRef;